export default function BannerSection() {
  return (
    <section className="bg-white px-0">
      <div className="relative bg-gradient-to-r from-secondary via-yellow-300 to-secondary p-12 md:p-20 overflow-hidden shadow-2xl">
        <div className="absolute -right-10 -top-10 w-64 h-64 bg-white/30 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute left-10 bottom-10 w-40 h-40 bg-white/20 rounded-full blur-2xl pointer-events-none" />
        <div className="absolute top-1/2 left-1/4 text-7xl opacity-10 pointer-events-none select-none">🎈</div>
        <div className="absolute top-10 right-1/3 text-6xl opacity-10 pointer-events-none select-none">🎊</div>
        <div className="absolute bottom-10 right-20 text-5xl opacity-10 pointer-events-none select-none">🎁</div>

        <div className="relative z-10 text-center max-w-3xl mx-auto">
          <div className="inline-block bg-white/40 backdrop-blur-sm px-6 py-3 rounded-full mb-6 border-2 border-white/60">
            <span className="font-black text-textDark">🎉 LIMITED TIME OFFER</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-textDark mb-6">Get 20% Off Your First Order!</h2>
          <p className="text-xl text-textDark mb-8 font-bold">Sign up today and unlock exclusive discounts! 🚀</p>
          <button className="bg-gradient-to-r from-primary to-primaryHover text-white font-black text-lg px-12 py-5 rounded-full shadow-2xl hover:shadow-xl transition-all transform hover:-translate-y-1 border-4 border-white">
            Claim Discount Now! 🎁
          </button>
        </div>
      </div>
    </section>
  );
}
